import React from 'react';
import { Styles } from './styles/contact.js';

const GoogleMap = () => {
    return (
        <Styles>
            <div className="google-map-area" style={{ width: '100%', height: '450px' }}>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.8206421147115!2d75.9311324!3d10.9012317!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7b196209c9b6f%3A0xaf978c8945f40d20!2sN.S.%20S.ENGLISH%20MEDIUM%20HIGH%20SCHOOL!5e0!3m2!1sen!2sin!4v1739469842854!5m2!1sen!2sin"
                    width="100%"
                    title="Google Map Location"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>
        </Styles>
    );
};

export default GoogleMap;
